class JwsWornGallery extends HTMLElement {
  connectedCallback() {
    if (this._controller) return;
    this._track = this.querySelector('[data-jws-gallery-track]');
    this._controls = this.querySelector('[data-jws-gallery-controls]');
    this._previous = this.querySelector('[data-jws-gallery-previous]');
    this._next = this.querySelector('[data-jws-gallery-next]');
    if (!this._track || !this._controls || !this._previous || !this._next) return;
    this._controller = new AbortController();
    const options = { signal: this._controller.signal };
    this._previous.addEventListener('click', () => this._move(-1), options);
    this._next.addEventListener('click', () => this._move(1), options);
    this._track.addEventListener('scroll', () => this._update(), { ...options, passive: true });
    this._track.addEventListener('keydown', (event) => {
      if (event.target !== this._track) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        this._move(event.key === 'ArrowLeft' ? -1 : 1);
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        this._track.scrollTo({ left: event.key === 'Home' ? 0 : this._track.scrollWidth, behavior: this._behavior() });
      }
    }, options);
    this.addEventListener('shopify:block:select', (event) => {
      if (!(event.target instanceof Element)) return;
      const card = event.target.closest('[data-jws-gallery-card]');
      if (card && this.contains(card)) {
        const left = this._track.scrollLeft + card.getBoundingClientRect().left - this._track.getBoundingClientRect().left;
        this._track.scrollTo({ left, behavior: 'instant' });
      }
    }, options);
    this._observer = new ResizeObserver(() => this._update());
    this._observer.observe(this._track);
    this._update();
  }

  disconnectedCallback() {
    this._controller?.abort();
    this._observer?.disconnect();
    this._controller = null;
  }

  _behavior() {
    return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  }

  _move(direction) {
    const card = this._track.querySelector('[data-jws-gallery-card]');
    const gap = parseFloat(getComputedStyle(this._track).columnGap) || 0;
    const distance = card ? card.getBoundingClientRect().width + gap : this._track.clientWidth;
    this._track.scrollBy({ left: direction * distance, behavior: this._behavior() });
  }

  _update() {
    const maximum = this._track.scrollWidth - this._track.clientWidth;
    this._controls.hidden = maximum <= 2;
    this._previous.disabled = this._track.scrollLeft <= 2;
    this._next.disabled = this._track.scrollLeft >= maximum - 2;
  }
}

if (!customElements.get('jws-worn-gallery')) customElements.define('jws-worn-gallery', JwsWornGallery);
